import { render, staticRenderFns } from "./ScoreTeamAnswers.vue?vue&type=template&id=68728e25&"
import script from "./ScoreTeamAnswers.vue?vue&type=script&lang=js&"
export * from "./ScoreTeamAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports